import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="w-full bg-background-100 py-10 md:py-14">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
          准备好开始创作了吗？
        </h2>
        <p className="text-sm text-foreground-500 mb-6 max-w-lg mx-auto leading-relaxed">
          加入蜜桃视频创作者社区，分享你的精彩生活，让世界看到你的创意与才华。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/about"
            className="px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm cursor-pointer hover:bg-primary-600 transition-all duration-300 transform hover:scale-105 whitespace-nowrap"
          >
            <i className="ri-user-add-line mr-2"></i>立即加入
          </Link>
          <Link
            to="/category/shenghuo"
            className="px-8 py-3 rounded-full bg-background-200 text-foreground-700 font-medium text-sm cursor-pointer hover:bg-background-300 transition-all duration-300 whitespace-nowrap"
          >
            <i className="ri-play-circle-line mr-2"></i>浏览内容
          </Link>
        </div>
      </div>
    </section>
  );
}